import { render, staticRenderFns } from "./SalesGroupTable.vue?vue&type=template&id=79db6041"
import script from "./SalesGroupTable.vue?vue&type=script&lang=js"
export * from "./SalesGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports